import { Component, OnInit } from '@angular/core';
import {makeDataObjects} from "./makedataobjects";

@Component({
  selector: 'app-heatmap',
  templateUrl: './heatmap.component.html',
  styleUrls: ['./heatmap.component.css']
})

export class HeatmapComponent implements OnInit {
  public data = makeDataObjects(24, 24);

  constructor() { }

  ngOnInit(): void {
  }

}
